import { axiosInstanceV2 } from "@bn/api";
import { TransactionsApiListAndSearchAllTransactionV2Request } from "@bn/api/apiv1";

export const downloadTransactions = async (
  token: string | undefined,
  params: TransactionsApiListAndSearchAllTransactionV2Request
) => {
  const { data } = await axiosInstanceV2.get<File>(`/transactions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "blob",
    params,
  });
  return data;
};
